import { useData } from "data/data-provider";
import Invoice from "designs/Common/(car-search-form)/invoice";
import LongTermRentalInvoice from "designs/Common/(car-search-form)/LongTermInvoice";
import moment from "moment";
import React, { useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

function LongTermRentalUI({
  handleBooking,
  loading,
  loadingLater,
  handleBookingLater,
  renterDetailsConfirmed,
}: any) {
  const {
    selectedCar,
    startDate,
    endDate,
    pickupLocation,
    invoice,
    dropOffLocation,
    dropoffLocationType,
    ourCompany,
    long_term_rental_nature,
    long_term_rental_duration,
  } = useData();

  return (
    <>
      <div className="listingSectionSidebar__wrap shadow-xl mt-4 lg:mt-0 p-6 lg:p-10 lg:max-w-xl  ">
        {pickupLocation && (
          <>
            {" "}
            <h2 className="text-2xl font-bold text-text-color mb-3">
              Booking Details
            </h2>
            <div className="mt-8 flex">
              <div className="flex-shrink-0 flex flex-col items-center py-2">
                <span className="block w-6 h-6 rounded-full border border-secondary-100"></span>
                <span className="block flex-grow border-l border-secondary-100 border-dashed my-1"></span>
                <span className="block w-6 h-6 rounded-full border border-secondary-100"></span>
              </div>
              <div className="ml-4 space-y-14 text-sm">
                <div className="flex flex-col space-y-2">
                  <span className=" text-text-color ">Pick up</span>
                  <span className="text-text-color font-semibold">
                    {" "}
                    {pickupLocation?.name}
                  </span>
                  {startDate && (
                    <span className=" font-semibold text-text-color !mt-0">
                      {moment(startDate).format("ddd, D MMM YYYY")}{" "}
                      {ourCompany?.default_time_format === "24_hour"
                        ? moment(startDate).format("H:mm")
                        : moment(startDate).format("h:mm A")}
                    </span>
                  )}
                </div>
                <div className="flex flex-col space-y-2">
                  <span className=" text-text-color ">Drop Off</span>
                  <span className="text-text-color font-semibold">
                    {dropoffLocationType === false && dropOffLocation?.name
                      ? dropOffLocation?.name
                      : pickupLocation?.name}
                  </span>
                  {endDate && (
                    <span className=" font-semibold text-text-color !mt-0">
                      {moment(endDate).format("ddd, D MMM YYYY")}{" "}
                      {ourCompany?.default_time_format === "24_hour"
                        ? moment(endDate).format("H:mm")
                        : moment(endDate).format("h:mm A")}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="listingSectionSidebar__wrap shadow-xl mt-5 p-6 lg:p-10 lg:max-w-xl  ">
        <LongTermRentalInvoice
          long_term_rental_nature={long_term_rental_nature}
          long_term_rental_duration={long_term_rental_duration}
          invoice={invoice}
          startDate={startDate}
          carName={selectedCar?.name}
        />
      </div>
      <div className="listingSectionSidebar__wrap shadow-xl mt-5 p-6 lg:p-10 lg:max-w-xl mb-10">
        <h2 className="text-2xl font-bold text-text-color">
          {long_term_rental_nature === "weekly"
            ? "Weekly Invoice"
            : "Monthly Invoice"}
        </h2>

        <div className="px-4 border-t border-secondary-100">
          <Invoice invoice={invoice} carName={selectedCar?.name} />
        </div>

        <ButtonPrimary
          className="block rounded-3xl"
          disabled={loading}
          onClick={() => {
            handleBooking();
          }}
        >
          {loading ? (
            <div className="flex justify-center items-center col-span-full">
              <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
            </div>
          ) : (
            "Pay & Book"
          )}
        </ButtonPrimary>
        {selectedCar?.pay_later && (
          <ButtonPrimary
            className="block rounded-lg mt-4"
            disabled={loadingLater}
            onClick={() => {
              handleBookingLater();
            }}
          >
            {loadingLater ? (
              <div className="flex justify-center items-center col-span-full">
                <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
              </div>
            ) : (
              "Pay Later"
            )}
          </ButtonPrimary>
        )}
      </div>
    </>
  );
}

export default LongTermRentalUI;
